<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="annual-leave-record-tab">
        <v-tabs
          v-model="activeInnerTab"
          background-color="grey lighten-3"
          class="elevation-0"
          color="blue"
        >
          <v-tab class="px-6">
            <v-icon size="20" class="mr-2">mdi-clipboard-text-outline</v-icon>
            特休假總覽
          </v-tab>
          <v-tab class="px-6">
            <v-icon size="20" class="mr-2">mdi-calendar-range</v-icon>
            特休假審核
          </v-tab>
          <v-tab class="px-6">
            <v-icon size="20" class="mr-2">mdi-calendar-range</v-icon>
            特休假紀錄
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeInnerTab" class="bg-white">
          <v-tab-item>
            <annual-leave-balances-widget
              ref="annualLeaveBalancesWidget"
              :selected-company="selectedCompany"
              @error="forwardError"
            />
          </v-tab-item>
          <v-tab-item>
            <annual-leave-records-widget
              ref="annualLeaveRecordsWidget"
              :selected-company="selectedCompany"
              :year="year"
              @error="forwardError"
            />
          </v-tab-item>
          <v-tab-item>
            <company-annual-leave-records-widget
              ref="companyAnnualLeaveRecordsWidget"
              :selected-company="selectedCompany"
              @error="forwardError"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AnnualLeaveRecordsWidget from "@/components/Widgets/AnnualLeaveRecordsWidget.vue";
import AnnualLeaveBalancesWidget from "@/components/Widgets/AnnualLeaveBalancesWidget.vue";
import CompanyAnnualLeaveRecordsWidget from "@/components/Widgets/CompanyAnnualLeaveRecordsWidget.vue";

export default {
  name: "AnnualLeaveRecordTab",
  components: {
    AnnualLeaveRecordsWidget,
    AnnualLeaveBalancesWidget,
    CompanyAnnualLeaveRecordsWidget,
  },
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
    year: {
      type: [String, Number],
      default: () => new Date().getFullYear(),
    },
  },
  data() {
    return {
      activeInnerTab: 0,
    };
  },
  watch: {
    activeInnerTab(newVal) {
      this.$nextTick(() => {
        if (newVal === 0) {
          this.$refs.annualLeaveBalancesWidget?.fetchLeaveBalances?.();
        } else if (newVal === 1) {
          this.$refs.annualLeaveRecordsWidget?.fetchAnnualLeaves?.();
        } else if (newVal === 2) {
          this.$refs.companyAnnualLeaveRecordsWidget?.fetchCompanyAnnualLeaves?.();
        }
      });
    },
  },
  methods: {
    forwardError(event) {
      this.$emit("error", event);
    },
    refresh() {
      this.$nextTick(() => {
        if (this.$refs.annualLeaveBalancesWidget?.fetchLeaveBalances) {
          this.$refs.annualLeaveBalancesWidget.fetchLeaveBalances();
        }
        if (this.$refs.annualLeaveRecordsWidget?.fetchAnnualLeaveRecords) {
          this.$refs.annualLeaveRecordsWidget.fetchAnnualLeaveRecords();
        }
        if (
          this.$refs.companyAnnualLeaveRecordsWidget?.fetchCompanyAnnualLeaves
        ) {
          this.$refs.companyAnnualLeaveRecordsWidget.fetchCompanyAnnualLeaves();
        }
      });
    },
  },
};
</script>

<style scoped>
.annual-leave-record-tab {
  min-height: 400px;
}
.v-tab--active {
  font-weight: bold !important;
  font-size: 1.05rem;
}
</style>
